import { render, staticRenderFns } from "./category-add-or-update.vue?vue&type=template&id=4c6d0d62&"
import script from "./category-add-or-update.vue?vue&type=script&lang=js&"
export * from "./category-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports